module.exports = __webpack_public_path__ + "static/trees-3.6-5588cef5128e87fb24238723048bb37e.png";